import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { ApiControllerService } from '../api-controller-service';
import { Role } from 'src/app/_helpers/auth.constants';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit {
  profileData: any = null;
  isLoading: boolean = false;
  error: string | null = null;
  isOpen = false;
  selectedOption = 'Select Security';

  constructor(
    private authService: AuthService,
    private router: Router,
    private apiControllerService: ApiControllerService
  ) {}

  ngOnInit(): void {
    this.loadProfile();
    this.loadSecurityType();
  }

  loadProfile(): void {
    this.isLoading = true;
    this.error = null;
    this.authService.getUserProfile().subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response?.response?.status === 200 && response?.response?.data) {
          this.profileData = response.response.data;
        } else {
          this.error = 'Failed to load profile data';
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Failed to fetch user profile:', err);
        this.error = err?.error?.message || err?.message || 'Failed to fetch user profile. Please try again.';
      }
    });
  }

  editPassword(): void {
    this.router.navigate(['/profile/change-password']);
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: string, event: Event) {
    event.stopPropagation();
    this.selectedOption = option;
    if("OTP" == option){
      this.selectedOption = "Email OTP";
    }else if("TFA" == option){
      this.selectedOption = "TOTP";
    }
    this.isOpen = false;

    let request = {
      "username" : this.profileData.emailId,
      "app" : "DEVELOPER_PORTAL",
      "securityType" : option
    }
    this.apiControllerService.changeSecurityType(request).subscribe((response:any)=>{
    })
  }

  private loadSecurityType() {
    this.apiControllerService.getSecurityType().subscribe((response:any)=>{
      if(response?.response?.data != null){
        this.selectedOption = response.response.data;
        if("OTP" == response.response.data){
          this.selectedOption = "Email OTP";
        }else if("TFA" == response.response.data){
          this.selectedOption = "TOTP";
        }
      }
    })
  }

  getRole(roleName: string): string {
    if(!roleName) {
      return 'N/A';
    }
    if (roleName === Role.PAY10_ADMIN) {
      return `Pay10 Admin`;
    }
    return roleName;
  }


}
